import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/feedbacks',
  children: {
    giveFeedback: {
      path: 'give_feedback',
    },
    given: {
      path: 'mine/given',
    },
    pendingRequests: {
      path: 'mine/pending_requests',
    },
  },
} as const satisfies Location
